import { IDialogsState } from '../../models';

export const dialogsState: IDialogsState = {};
